<template>
  <div>
    我的活动
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>